// app/src/onboarding-utils.js
// Pure helpers for the first-run onboarding wizard. No React, no Supabase,
// no DOM — testable in isolation.

export function slugifyHotelName(name) {
  const slug = String(name || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')         // strip combining diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')             // non-alphanumerics → hyphen
    .replace(/^-+|-+$/g, '');                // trim leading/trailing hyphens
  return slug || 'hotel';
}

export function countryToCurrency(country) {
  return country === 'GB' ? 'GBP' : 'EUR';
}

export function defaultLangForCountry(country) {
  return country === 'BG' ? 'bg' : 'en';
}

// Used by App.jsx to decide whether to mount the wizard, and which step
// to start on. Returns:
//   'hotel'        — no row exists, show Step 1
//   'rooms'        — Step 1 done, show Step 2
//   'booking_page' — Step 2 done, show Step 3
//   null           — onboarding is complete, render the normal app
//
// A row that exists but has a NULL/missing onboarding_step is treated as
// 'done' (legacy property rows that pre-date this feature; backfilled by
// migration 018 but defensive in case the migration hasn't run yet).
export function wizardStepFromProperty(property) {
  if (!property) return 'hotel';
  const step = property.onboarding_step;
  if (step === 'rooms') return 'rooms';
  if (step === 'booking_page') return 'booking_page';
  return null; // 'done', null, missing — all mean "no wizard"
}
